import { QueryConfig } from "store/utils/query-config";

export const conversionWidgetsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["createdAt"]
  }
};
